import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {FITH2SlideShowPage} from "./FITH2SlideShowPage";
import {FireInTheHole2} from "../FireInTheHole2";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
export class FITH2IntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000, //Default 0x000000
            backgroundAlpha:0.6, //Default 0.4
            bulletColor:0xffffff, //Default 0xffffff

        },
        stampColor:0xFFFFFF
    };
    continueButtonClickSound:string = "continueButton";
    stampConfig:StampConfig = {
        xBet:true,
        xBomb:true,
        xSplit:true,
        volatility:Volatility.EXTREME
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];
    private betBoostAllowed: boolean = false;
    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/introBackground.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("feature2_US", "resources/images/intro_feature2_US.png");
        imgLoader.add("feature3", "resources/images/intro_feature3.png");
        imgLoader.add("xbet", "resources/images/xbet.png");
        imgLoader.add("logo", "resources/images/introLogo.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        return new Promise((resolve, reject) => {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        logoSprite.position.set(-5, 18);
        this.logo.addChild(logoSprite);

        this.pages=[];
        this.betBoostAllowed = FireInTheHole2.apiPlugin.gameClientConfiguration.boostedBetAllowed;

        if (FireInTheHole2.apiPlugin.gameClientConfiguration.isSet) {
            if (FireInTheHole2.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                this.addBoostPage();
            }
            resolve(this);
        } else {
            FireInTheHole2.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (FireInTheHole2.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                    this.addBoostPage();
                }
                resolve(this);
            });
        }
        });
    }
    gameClientConfigurationApplied():void{
        if(FireInTheHole2.apiPlugin.gameClientConfiguration.showMultipliersInfo!==undefined && !FireInTheHole2.apiPlugin.gameClientConfiguration.showMultipliersInfo){
            this.pages = [
                new FITH2SlideShowPage(ImgLoader.getImgTexture("feature1")),
                new FITH2SlideShowPage(ImgLoader.getImgTexture("feature2_US")),
                new FITH2SlideShowPage(ImgLoader.getImgTexture("feature3"))
            ];
        }else {
            this.pages = [
                new FITH2SlideShowPage(ImgLoader.getImgTexture("feature1")),
                new FITH2SlideShowPage(ImgLoader.getImgTexture("feature2")),
                new FITH2SlideShowPage(ImgLoader.getImgTexture("feature3"))
            ];
        }
    }

    private addBoostPage() {
        const xbetSprite = new FITH2SlideShowPage(ImgLoader.getImgTexture("xbet"));
        this.pages.splice(3, 0, xbetSprite);
    }

    onShow() {
        this.logo.parent.addChild(this.logo);
    }
}